import { useLocale } from '@ecomm/data-hooks'
import { ukData, usData } from './data'
import { userStoriesSchema } from './schema'

export const useMonitoringPageUserStoriesData = () => {
  const userStoriesData = useLocale() === 'en-US' ? usData : ukData

  return userStoriesSchema.parse(userStoriesData)
}
